import { motion } from "framer-motion";
import { MapPin, Navigation } from "lucide-react";

const CENTER = ["Karatay", "Selçuklu", "Meram"];
const DISTRICTS = [
  "Akşehir", "Ereğli", "Beyşehir", "Seydişehir", "Cihanbeyli", "Kulu", "Ilgın",
  "Çumra", "Yunak", "Kadınhanı", "Sarayönü", "Doğanhisar", "Şarkıkaraağaç",
  "Bozkır", "Taşkent", "Halkapınar",
];
const CITIES = [
  "Ankara", "İstanbul", "İzmir", "Antalya", "Mersin", "Adana", "Karaman",
  "Aksaray", "Kayseri", "Eskişehir", "Niğde", "Kütahya",
];

export default function Coverage() {
  return (
    <section id="bolgeler" data-testid="coverage-section" className="py-16 lg:py-24 scroll-mt-20 relative">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand/40 to-transparent" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Hizmet Bölgeleri</p>
            <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-[0.95]">
              Neredeyseniz
              <br />
              <span className="text-outline">oradayız</span>
            </h2>
            <p className="text-slate-400 mt-5 max-w-xl leading-relaxed">
              Konya'nın merkez ilçelerinde dakikalar içinde, tüm ilçelerinde ve Türkiye'nin her
              noktasında araç çekme hizmeti veriyoruz. Konumunuzu paylaşın, yeter.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-8"
          >
            <p className="text-sm uppercase tracking-widest text-slate-400 mb-3 flex items-center gap-2">
              <MapPin className="w-4 h-4 text-brand" /> Merkez ilçeler
            </p>
            <div className="flex flex-wrap gap-2">
              {CENTER.map((d) => (
                <span key={d} className="rounded-full bg-brand text-night-900 font-bold px-4 py-1.5 text-sm" data-testid={`center-district-${d}`}>
                  {d}
                </span>
              ))}
            </div>
            <p className="text-sm uppercase tracking-widest text-slate-400 mt-6 mb-3">Tüm Konya ilçeleri</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="districts-grid">
              {DISTRICTS.map((d) => (
                <span key={d} className="rounded-lg border border-white/10 bg-night-800/60 px-3 py-2 text-sm text-slate-300 text-center hover:border-brand/50 hover:text-brand transition-colors duration-200">
                  {d}
                </span>
              ))}
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <div className="relative rounded-2xl overflow-hidden border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1763377278900-0ce8242c5005?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Yol kenarında çekici hizmeti"
              className="w-full h-[380px] lg:h-[460px] object-cover duotone-img"
              loading="lazy"
              data-testid="coverage-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-night-900 via-night-900/40 to-transparent" aria-hidden="true" />
            <div className="absolute top-4 right-4 flex items-center gap-2 rounded-full bg-brand text-night-900 font-bold px-4 py-2 text-sm shadow-[0_0_24px_rgba(255,107,0,0.5)]">
              <Navigation className="w-4 h-4" strokeWidth={2.5} />
              Tüm Türkiye
            </div>
            <div className="absolute bottom-0 inset-x-0 p-6">
              <p className="font-display font-bold uppercase text-2xl text-white">İl dışı taşımacılık</p>
              <p className="text-sm text-slate-300 mt-1">Konya'dan aşağıdaki illere ve her noktaya düzenli araç taşıyoruz:</p>
              <div className="flex flex-wrap gap-1.5 mt-3">
                {CITIES.map((c) => (
                  <span key={c} className="rounded-full bg-night-900/80 border border-white/15 px-2.5 py-1 text-xs text-slate-200">
                    {c}
                  </span>
                ))}
                <span className="rounded-full border border-brand/60 px-2.5 py-1 text-xs text-brand">+ tüm iller</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
